(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fgr-real-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('.fgr-grid');
    if (grid) {
      const cards = [...grid.children];
      const diversify = items => {
        const groups = new Map();
        items.forEach(card => {
          const key = card.dataset.reviewerGroup;
          if (!groups.has(key)) groups.set(key,{key,cards:[],rank:Number(card.dataset.reviewOrder)});
          groups.get(key).cards.push(card);
        });
        const mixed = [], recent = [];
        while (groups.size) {
          const remaining = [...groups.values()];
          let available = remaining.filter(group => !recent.includes(group.key));
          if (!available.length) available = remaining.filter(group => group.key !== recent[recent.length-1]);
          if (!available.length) available = remaining;
          const chosen = available.reduce((best,group) => !best || group.cards.length > best.cards.length || (group.cards.length === best.cards.length && group.rank < best.rank) ? group : best,null);
          mixed.push(chosen.cards.shift());
          recent.push(chosen.key);
          if (recent.length > 17) recent.shift();
          if (!chosen.cards.length) groups.delete(chosen.key);
        }
        return mixed;
      };
      const currentProduct = root.dataset.currentProduct;
      const productCards = currentProduct ? cards.filter(card => card.dataset.reviewProduct === currentProduct) : [];
      const productFilter = root.querySelector('[data-scope="product"]');
      const storeFilter = root.querySelector('[data-scope="store"]');
      const photoFilter = root.querySelector('[data-with-photos]');
      const count = root.querySelector('[data-result-count]');
      const pagination = root.querySelector('.fgr-pagination');
      let scope = productCards.length ? 'product' : 'store';
      const mobileViewport = window.matchMedia('(max-width:700px)');
      const pageSize = () => mobileViewport.matches ? 3 : 6;
      let rating = 'all', withPhotos = false, limit = pageSize(), order = 'mixed';
      if (productFilter) {
        productFilter.hidden = !productCards.length;
        productFilter.querySelector('span').textContent = productCards.length;
      }
      const render = () => {
        const base = scope === 'product' ? productCards : cards;
        const matches = base.filter(card => (rating === 'all' || card.dataset.rating === rating) && (!withPhotos || card.querySelector('.fgr-photos img')));
        const ordered = order === 'recent' ? matches.sort((a,b) => Number(a.dataset.reviewOrder)-Number(b.dataset.reviewOrder)) : diversify(matches);
        ordered.forEach(card => grid.append(card));
        cards.forEach(card => { card.hidden = true; });
        ordered.slice(0,limit).forEach(card => { card.hidden = false; });
        root.querySelector('[data-sort]').setAttribute('aria-pressed',String(order === 'recent'));
        if (productFilter) productFilter.setAttribute('aria-pressed',String(scope === 'product'));
        storeFilter.setAttribute('aria-pressed',String(scope === 'store' && (!!currentProduct || (rating === 'all' && !withPhotos))));
        root.querySelectorAll('[data-stars]').forEach(button => {
          button.setAttribute('aria-pressed',String(button.dataset.stars === rating));
          button.querySelector('span').textContent = base.filter(card => card.dataset.rating === button.dataset.stars).length;
        });
        photoFilter.setAttribute('aria-pressed',String(withPhotos));
        photoFilter.querySelector('span').textContent = base.filter(card => card.querySelector('.fgr-photos img')).length;
        const total = matches.length;
        count.textContent = !total ? count.dataset.empty : total === 1 ? count.dataset.one : count.dataset.pattern.replace('__shown__',Math.min(limit,total)).replace('__total__',total);
        pagination.hidden = total <= limit;
        const average = base.reduce((sum,card) => sum + Number(card.dataset.rating),0) / base.length;
        root.querySelector('[data-summary-score]').textContent = average.toFixed(1);
        const label = root.querySelector('[data-summary-label]');
        label.textContent = average >= 4.5 ? label.dataset.excellent : label.dataset.great;
        const summaryCount = root.querySelector('[data-summary-count]');
        summaryCount.textContent = base.length === 1 ? summaryCount.dataset.one : summaryCount.dataset.pattern.replace('__count__',base.length);
        [...root.querySelector('[data-summary-stars]').children].forEach((star,index) => {
          const fill = Math.max(0,Math.min(1,average-index))*100;
          star.style.background = `linear-gradient(to right,var(--fgr-green) ${fill}%,#d6dbe1 ${fill}%)`;
        });
        root.querySelectorAll('[data-bar-rating]').forEach(row => {
          const n = base.filter(card => card.dataset.rating === row.dataset.barRating).length;
          const meter = row.querySelector('meter');
          meter.max = base.length;
          meter.value = n;
          meter.textContent = `${n}/${base.length}`;
          row.querySelector('b').textContent = `${Math.round(n/base.length*100)}%`;
        });
      };
      const setScope = value => { scope = value; rating = 'all'; withPhotos = false; limit = pageSize(); order = 'mixed'; render(); };
      productFilter?.addEventListener('click',() => setScope('product'));
      storeFilter.addEventListener('click',() => setScope('store'));
      root.querySelectorAll('[data-stars]').forEach(button => button.addEventListener('click',() => { rating = button.dataset.stars; limit = pageSize(); render(); }));
      photoFilter.addEventListener('click',() => { withPhotos = !withPhotos; limit = pageSize(); render(); });
      root.querySelector('.fgr-all-link')?.addEventListener('click',() => setScope('store'));
      root.querySelector('[data-load-more]').addEventListener('click',() => { limit += pageSize(); render(); });
      root.querySelector('[data-sort]').addEventListener('click',() => {
        order = order === 'recent' ? 'mixed' : 'recent';
        limit = pageSize();
        render();
      });
      mobileViewport.addEventListener('change',() => { limit = pageSize(); render(); });
      root.querySelector('.fgr-tools').hidden = false;
      render();
    }
    const pause = root.querySelector('[data-pause]');
    if (pause) pause.addEventListener('click',() => {
      const paused = root.dataset.paused !== 'true';
      root.dataset.paused = String(paused);
      pause.setAttribute('aria-pressed',String(paused));
      pause.setAttribute('aria-label',paused ? pause.dataset.play : pause.dataset.pauseLabel);
      pause.textContent = paused ? '▷' : 'Ⅱ';
    });
  };
  const scan = () => document.querySelectorAll('.fgr').forEach(init);
  scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
